import { post, get } from '@/utils/request'

export async function runStatus() {
  return await get('/qtune/run-status', {}, {})
}

export async function startRun() {
  return await post('/qtune/run', {}, {})
}

export async function stopRun() {
  return await post('/qtune/stop', {}, {})
}

export async function runLog() {
  return await get('/qtune/run-log', {}, {})
}

export async function configContent() {
  return await get('/qtune/config-content', {}, {})
}

export async function modifiyConfigContent(args) {
  return await post('/qtune/modifiy-config-content', args, {})
}

export async function currentTuneRes() {
  return await get('/qtune/current-tune-res', {}, {})
}

export async function historyTuneRes() {
  return await get('/qtune/history-tune-res', {}, {})
}
